/**
 * Konfidenzanzeige mit den Schwellen aus dem Mockup: ab 0,80 sicher, ab 0,60 mittel,
 * darunter ausdrueckliche Bitte um Pruefung (P5-03).
 */
export default function Konfidenz({ wert }: { wert: number | null | undefined }) {
  if (wert === null || wert === undefined) {
    return null
  }

  const klasse = wert >= 0.8 ? 'konf-hoch' : wert >= 0.6 ? 'konf-mittel' : 'konf-tief'
  const text = `Konfidenz ${Math.round(wert * 100)}%${wert < 0.6 ? ' · bitte prüfen' : ''}`

  return <span className={`chip ${klasse}`}>{text}</span>
}
